import { useContext } from 'react';

import { ModalContext } from 'contexts/ModalContext';

// This custom hook allows us to open and close non-routed modals,
// i.e. modals that do not have their own URL.
//
// Routed modals: For modals that should have their own URL, do this instead:
// 1) Add a nested route to the parent route in the route configuration, e.g.:
//    <Route path={ROUTES.HOME} element={<HomePage />}>
//        <Route path={ROUTES.HOME_POST_PHOTO} element={<PostPhotoModal />} />
//   </Route>
//
// 2) Use the useRouteBranch hook to navigate to the parent route when the modal is closed, e.g.:
//    const { navigateToBranchParent } = useRouteBranch();
//
// 3) Use the OutletModalContainer component to wrap the modal's parent content:
//    <OutletModalContainer onCloase={navigateToBranchParent}> ... </OutletModalContainer>
export default function useModal() {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error('useModal must be used within a ModalProvider');
    }

    return context;
}
